export function getConvertedRoundedAmount(
  amount: number,
  baseCurrencyExchangeRate: number,
  targetCurrencyExchangeRate: number,
): number {
  return Math.round(
    (amount * baseCurrencyExchangeRate) / targetCurrencyExchangeRate,
  );
}
